export default __webpack_public_path__ + "static/media/stamp.a42a4a97.svg";